import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cop31_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("cop31_token"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "cop31_token" && e.oldValue !== e.newValue) window.location.reload();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("cop31_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("cop31_token");
    setUser(null);
  };

  const updateUser = (data) => setUser((u) => (u ? { ...u, ...data } : u));

  return <AuthContext.Provider value={{ user, loading, login, logout, updateUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
